
// Entry point for all styles
import './jquery.js';
import "@popperjs/core";
import 'bootstrap';
//import * as bootstrap from 'bootstrap'
import "../../assets/stylesheets/application.scss";

// Fontawesome
import "@fortawesome/fontawesome-free/js/all";


// import phoenix.js
//  import '../../assets/vendor/js/config.js'
//  import '../../assets/vendor/js/phoenix.js'

// Additional libraries
import './datetimepicker_flatpickr.js';
import './select2.js';
import './popover.js';
import './search-filters.js';
//import 'feather-icons/dist/feather.min.js';



//simple bar
import 'simplebar'; // or "import SimpleBar from 'simplebar';" if you want to use it manually.
//import 'simplebar/dist/simplebar.css';
import 'simplebar/dist/simplebar.min.css';

// You will need a ResizeObserver polyfill for browsers that don't support it! (iOS Safari, Edge, ...)
import ResizeObserver from 'resize-observer-polyfill';
window.ResizeObserver = ResizeObserver;

//import 'echarts'
//import 'chart.js'
// import { Chart } from "chart.js";
// //import "chartkick/chart.js"
// import './dashboard.js'

// import all vendors assets
//const modules =import.meta.globEager("../../assets/**/*.png");

// Import all stimulus controllers
import "../controllers/index.js";

import "./google_analytics_turbo.js";

import * as Turbo from '@hotwired/turbo'
Turbo.start()

//Turbo.config.forms.mode = "off" // "optin"
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
//const channels = import.meta.globEager('./**/*_channel.js')

